mutation responsibilityCube(
  $scenarioId: ID!
  $originId: ID!
  $input: InstructorResponsibilityInput
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    instructorResponsibilityUpsert(input: $input) {
      skippedValidations
      commited
      validations {
        ... on InvalidInput {
          code
          meta
        }
      }
    }
  }
}
